export default {
  default: {
    addEvents: 'Add Events',
  },
}
